import { createSelector } from 'reselect'
import { isAdminUserUtil } from 'models/daos/user/utils'
import getCurrentUserSelector from 'modules/users/selectors/get-current'

function isAdminUserSelector () {
  return createSelector(
    getCurrentUserSelector(),
    currentUser => isAdminUserUtil(currentUser)
  )
}

export {
  isAdminUserSelector
}
